import React from 'react'
import { observer } from 'mobx-react'
import { FrameValue } from 'react-spring'
import Button from 'components/Button'
import {
  StickyViewHeader,
  StickyViewHeaderExtras,
  StickyViewHeaderMain,
} from 'components/StickyViewHeader'
import WorkspaceSelectorViewHeading from 'components/WorkspaceSelectorViewHeading'
import { UserManagementViewModel } from 'user-management/views/UserManagement/UserManagementViewModel'

interface WorkspaceSwitcherProps {
  scrollOffset: FrameValue<number>
  vm: UserManagementViewModel
}

export default observer(({ scrollOffset, vm }: WorkspaceSwitcherProps) => {
  const workspaceSelectorVM = vm.workspaceSelector
  return (
    <StickyViewHeader scrollOffset={scrollOffset}>
      <StickyViewHeaderMain>
        <WorkspaceSelectorViewHeading
          primaryText="User Management"
          dropdownTitle="Select Workspace"
          allOptionText={
            workspaceSelectorVM.canManageAll ? 'All workspaces' : null
          }
          workspaces={workspaceSelectorVM.filteredWorkspaces}
          value={workspaceSelectorVM.selectedWorkspace}
          onChange={workspaceSelectorVM.selectWorkspace}
          searcher={workspaceSelectorVM}
          alwaysUseDropdown={true}
        />
      </StickyViewHeaderMain>
      {workspaceSelectorVM.canInviteUsers && (
        <StickyViewHeaderExtras>
          <Button
            type="secondary"
            data-test="user-management-invite-button"
            onClick={() => vm.workspaceInvitationVM.showWithSelections()}
          >
            Invite
          </Button>
        </StickyViewHeaderExtras>
      )}
    </StickyViewHeader>
  )
})
